export default "/assets/images/big-sneeze-hero.54f94f7a1bbf32cf.png";